import React from "react";


const SectionTabButtons = ({handleNaviTab, currentNaviTab}) => {

  return (
    <div className={"exterior-interior-buttons"}>
      <button
        type={"button"}
        onClick={() => handleNaviTab("EXT")}
        className={currentNaviTab === "EXT" ? "active" : ""}
      >
        EXTERIOR
      </button>
      <button
        type={"button"}
        onClick={() => handleNaviTab("INT")}
        className={currentNaviTab === "INT" ? "active" : ""}
      >
        INTERIOR
      </button>
    </div>

  )
}

export default SectionTabButtons;
